const initialState = {
  qcDurations: {} as Record<string, number>,
  loading: false,
  error: null,
};
const resultReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case 'UPDATE_QC_DURATION':
      const { id, duration } = action.payload;
      return {
        ...state,
        qcDurations: {
          ...state.qcDurations,
          [id]: (state.qcDurations[id] || 0) + duration
        }
      };
    case 'RESET_QC_DURATION':
      return {
        ...state,
        qcDurations: {
          ...state.qcDurations,
          [action.payload.id]: 0
        }
      };
    default:
      return state;
  }
}
export default resultReducer;